import * as PhotoStatus from '../../../../../../../shared/PhotoStatus';
import { ImageCategory } from '../../shared/state/utils';

let PIN_ELIGIBLE_STATUSES = [
    PhotoStatus.CustomerApproved,
    PhotoStatus.DeliveryStarted,
    PhotoStatus.Delivered,
    PhotoStatus.DeliveryError,
    PhotoStatus.SetToRedeliver
];

export function canPlacePinForStatus(photoStatus: number): boolean {
    return PIN_ELIGIBLE_STATUSES.indexOf(photoStatus) !== -1;
}

export const PIN_PATH = 'M12 35 C12 35 1 20.5 1 12 A11 11 0 0 1 23 12 C23 20.5 12 35 12 35 Z';
export const PIN_VIEWBOX_WIDTH = 24;
export const PIN_VIEWBOX_HEIGHT = 36;
export const PIN_TIP_Y = 35;
export const PIN_STROKE_WIDTH = 2;
export const PIN_INNER_CIRCLE_RADIUS = 4.5;

export const MIN_PIN_SIZE_PERCENT = 1;
export const MAX_PIN_SIZE_PERCENT = 25;
export const PIN_SIZE_STEP_PERCENT = 0.5;
export const DEFAULT_PIN_SIZE_PERCENT = 6;
export const DEFAULT_PIN_COLOR = '#e53935';
export const PRESET_PIN_COLORS = ['#e53935', '#ffffff', '#000000', '#fdd835', '#1e88e5', '#43a047'];

export type Size = {
    width: number;
    height: number;
};

export type Point = {
    x: number;
    y: number;
};

function clampFraction(value: number): number {
    return Math.min(1, Math.max(0, value));
}

export function pinSizeInPixels(imageSize: Size, sizeFraction: number): Size {
    let width = imageSize.width * sizeFraction;
    return { width, height: (width * PIN_VIEWBOX_HEIGHT) / PIN_VIEWBOX_WIDTH };
}

function tipOffset(pinSize: Size): Point {
    return { x: pinSize.width / 2, y: (pinSize.height * PIN_TIP_Y) / PIN_VIEWBOX_HEIGHT };
}

export function pinTopLeftFromTip(tip: Point, pinSize: Size): Point {
    let offset = tipOffset(pinSize);
    return { x: tip.x - offset.x, y: tip.y - offset.y };
}

export function tipFromPinTopLeft(topLeft: Point, pinSize: Size): Point {
    let offset = tipOffset(pinSize);
    return { x: topLeft.x + offset.x, y: topLeft.y + offset.y };
}

export function toPinFraction(tip: Point, imageSize: Size): Point {
    if (imageSize.width <= 0 || imageSize.height <= 0) {
        return { x: 0.5, y: 0.5 };
    }

    return {
        x: clampFraction(tip.x / imageSize.width),
        y: clampFraction(tip.y / imageSize.height)
    };
}

export function canPlacePinOnImage(
    effectiveCategory: number,
    image: { isPinned: boolean; isStitched: boolean }
): boolean {
    return effectiveCategory === ImageCategory.Normal && !image.isPinned && !image.isStitched;
}

export function pinDragBounds(imageSize: Size, pinSize: Size) {
    let offset = tipOffset(pinSize);
    return {
        left: -offset.x,
        top: -offset.y,
        right: imageSize.width - offset.x,
        bottom: imageSize.height - offset.y
    };
}
